
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/story",
      function () {
        return require("private-next-pages/node/story.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/story"])
      });
    }
  